module.exports = __webpack_public_path__ + "img/BFC.f0918623.png";